import { postRequest } from '../clients/axios';
import { OrderSearchRequest, OrderSearchResponse } from '../models';

export const postSearchOrders = async (request: OrderSearchRequest) => {
  const response = await postRequest<OrderSearchResponse>('orders/search', request);
  return response.data;
};
